import { api } from './api';

export interface SituacaoVendedor {
  id: number;
  descricao: string;
}

export const SITUACOES_VENDEDOR: SituacaoVendedor[] = [
  { id: 1, descricao: 'ATIVO' },
  { id: 2, descricao: 'BLOQUEADO POR FALTA DE PAGAMENTO' },
  { id: 3, descricao: 'BLOQUEADO POR NAO DEVOLUCAO' },
  { id: 4, descricao: 'BLOQUEADO POR CPF NEGATIVADO NO SPC' },
  { id: 5, descricao: 'PAROU DE VENDER' },
];

export interface VendedorPagamentoItem {
  id: number;
  valorPago: number;
  dataPagamento: string;
  dataInclusao: string;
}

export interface VendedorPagamento {
  id: number;
  idNotaEntradaRetorno: number;
  totalVenda: number;
  percentualVendedora: number;
  valorASerPago: number;
  totalPago: number;
  saldo: number;
  vendedorPagamentoItem: VendedorPagamentoItem[];
}

export interface Vendedor {
  id: number;
  cpf: string;
  nome: string;
  dataNascimento: string;
  telefone?: string;
  telefone1: string;
  telefone2: string;
  rg: string;
  idPraca: number;
  praca?: string; // Para exibição na tabela
  cep: string;
  cidade: string;
  bairro: string;
  rua: string;
  numero: string;
  situacao: string;
  situacaoId?: number;
  uf: string;
  totalDivida: number;
  saldoDevedor?: number; // Para exibição na tabela
  vendedorPagamento?: VendedorPagamento[];
}

export interface VendedorRequest {
  id?: number;
  cpf: string;
  nome: string;
  dataNascimento: string;
  telefone1: string;
  telefone2: string;
  rg: string;
  codPraca: number;
  cep: string;
  cidade: string;
  bairro: string;
  rua: string;
  numero: string;
  situacao: string;
  uf: string;
  totalDivida: number;
}

export interface VendedorUnificarRequest {
  idPermanecer: number;
  idExcluir: number;
}

export const vendedorService = {
  // Buscar todos os vendedores para tabela
  getTableVendedores: async (): Promise<Vendedor[]> => {
    const response = await api.get<Vendedor[]>('/api/Vendedor/GetTableVendedores');
    return response.data;
  },

  // Buscar vendedores por praça
  getVendedoresByPraca: async (idPraca: number): Promise<Vendedor[]> => {
    const response = await api.get<Vendedor[]>(`/api/Vendedor/GetVendedorSelect?idPraca=${idPraca}`);
    return response.data;
  },

  // Validar CPF não cadastrado
  validarCPFNaoCadastrado: async (cpf: string): Promise<boolean> => {
    const response = await api.get<boolean>(`/api/Vendedor/ValidarCPFnaoCadastrado?cpf=${cpf}`);
    return response.data;
  },

  // Salvar novo vendedor
  salvarNovoVendedor: async (vendedor: VendedorRequest): Promise<Vendedor> => {
    const response = await api.post<Vendedor>('/api/Vendedor/SalvarNovoVendedor', vendedor);
    return response.data;
  },

  // Editar vendedor
  editarVendedor: async (vendedor: VendedorRequest): Promise<Vendedor> => {
    const response = await api.post<Vendedor>('/api/Vendedor/EditarVendedor', vendedor);
    return response.data;
  },

  // Buscar vendedor por ID
  getById: async (id: number): Promise<Vendedor> => {
    const response = await api.get<Vendedor>(`/api/Vendedor/GetById?id=${id}`);
    return response.data;
  },

  // Unificar vendedores
  unificar: async (idPermanecer: number, idExcluir: number): Promise<void> => {
    const request: VendedorUnificarRequest = {
      idPermanecer,
      idExcluir
    };
    await api.post('/api/Vendedor/UnificarVendedor', request);
  },
};
